import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { ContaCaixaConfiguracao } from '../../../models/conta-caixa-configuracao';
import { TipoLancamentoConfiguracao } from '../../../models/tipo-lancamento-configuracao';
import { ConfiguracaoCaixaApiService } from '../../../services/configuracao-caixa-api.service';
import { MessageService } from '@services/message.service';
import { AlterarContaTipoRetorno } from '../../../models/alterar-conta-tipo-retorno';

@Component({
  selector: 'app-alterar-conta-do-tipo-dialog',
  standalone: false,
  templateUrl: './alterar-conta-do-tipo-dialog.component.html',
  styleUrl: './alterar-conta-do-tipo-dialog.component.scss'
})
export class AlterarContaDoTipoDialogComponent {

  title: string = 'Alterar conta do tipo';
  tipoAtual?: TipoLancamentoConfiguracao;
  contaDoTipo?: ContaCaixaConfiguracao;
  contas: ContaCaixaConfiguracao[] = [];

  contaSelecionada?: ContaCaixaConfiguracao;

  get tooltipContent(): string {
    return `Lançamentos do tipo "${this.tipoAtual?.nome}" anteriores a esta data serão conciliados automaticamente após a mesclagem.
      Deixe em branco para não conciliar nenhum.`;
  }

  constructor(
    private configuracaoCaixaApiService: ConfiguracaoCaixaApiService,
    private messageService: MessageService,
    private dialogRef: MatDialogRef<AlterarContaDoTipoDialogComponent>
  ) { }


  public salvarClick(): void {
    if (!this.contaSelecionada) {
      this.messageService.showToastWarning('Selecione uma conta destino para a mesclagem');
      return;
    }
    if (this.contaSelecionada.id == this.contaDoTipo?.id) {
      this.messageService.showToastWarning('A conta selecionada é a mesma que a conta atual do tipo');
      return;
    }

    const retorno: AlterarContaTipoRetorno = {
      tipoId: this.tipoAtual!.id,
      contaDestinoId: this.contaSelecionada!.id
    }

    this.configuracaoCaixaApiService.alterarContaTipo(retorno).subscribe(() => {
      this.messageService.showToastSuccess("Salvo com sucesso");
      this.dialogRef.close(true);
    });
  }
}
